import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import { Grid, Fade } from '@material-ui/core'

import Button from 'components/CustomButtons/Button.jsx'
import GridContainer from 'components/Grid/GridContainer'
import GridItem from 'components/Grid/GridItem'

import { germiniDefaultColors } from 'assets/jss/material-dashboard-pro-react'

import { ModalContainer, PaperContainer } from './styles'
import { ButtonClose } from 'components/NewButton/styles'
import { Box, Typography } from '@mui/material'
import { IconInfor } from '../../../../assets/icons_svg'

function ModalResendSms({
    t,
    className,
    closeByClick,
    handleSendSms,
    handleClose,
    maxWidth,
    minWidth,
    open,
    shadow,
    themeColor,
}) {
    return (
        <ModalContainer
            open={open}
            className={className}
            onClose={closeByClick}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            shadow={shadow}
            maxwidth={maxWidth}
            minwidth={minWidth}
            disableEnforceFocus
            style={{
                backdropFilter: 'blur(4px)',
            }}
        >
            <Fade in={open} unmountOnExit>
                <PaperContainer maxwidth={maxWidth}>
                    <Box display="flex" flexDirection="column" gap={2} p={3}>
                        <Box display="flex" justifyContent="flex-end">
                            <Box
                                component="i"
                                onClick={handleClose}
                                className="icon-ico_cancelar"
                                fontSize="20px"
                                color="#e01e36"
                                sx={{ cursor: 'pointer' }}
                            />
                        </Box>
                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <IconInfor
                                sx={{
                                    pb: '16px',
                                    fontSize: '90px !important',
                                    color:
                                        themeColor?.visual?.icons?.color ||
                                        '#eea236',
                                }}
                            />
                        </Box>
                        <Box textAlign="center">
                            <Typography variant="body2" fontSize="15px" mb={2}>
                                {t(
                                    'You have not yet validated the cell phone registered',
                                )}
                                . <br />
                                {t(
                                    'A new SMS will be sent with the confirmation',
                                )}
                                . <br />
                                {t('Click on validation')}.
                                <br />
                            </Typography>
                        </Box>
                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Button
                                size="sm"
                                variant="contained"
                                color={'greenButtonColor'}
                                defaultTheme={themeColor}
                                onClick={handleSendSms}
                            >
                                {t('Continue')}
                            </Button>
                        </Box>
                    </Box>
                </PaperContainer>
            </Fade>
        </ModalContainer>
    )
}

ModalResendSms.propTypes = {
    children: PropTypes.element,
    className: PropTypes.string,
    closeByClick: PropTypes.func,
    handleClose: PropTypes.func,
    handleSendSms: PropTypes.func,
    maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    open: PropTypes.bool,
    padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    shadow: PropTypes.string,
}

ModalResendSms.defaultProps = {
    children: null,
    className: '',
    closeByClick: null,
    handleClose: null,
    handleSendSms: null,
    maxWidth: '',
    minWidth: '',
    open: false,
    padding: '',
    shadow: '',
}

export default withTranslation()(ModalResendSms)
